import { render, staticRenderFns } from "./transfromToIIqBill.vue?vue&type=template&id=142780c4&scoped=true&"
import script from "./transfromToIIqBill.vue?vue&type=script&lang=js&"
export * from "./transfromToIIqBill.vue?vue&type=script&lang=js&"
import style0 from "./transfromToIIqBill.vue?vue&type=style&index=0&id=142780c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142780c4",
  null
  
)

component.options.__file = "transfromToIIqBill.vue"
export default component.exports